import { Typography } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useThemeMode } from '../../components/theme';
import { InfoTooltip } from '../../consts';
import { getPageInfo } from '../../helpers';
import AppBreadcrumbs from './breadcrumbs';

const AppTitle = () => {
    const location = useLocation();
    const pageInfo = getPageInfo(location.pathname);
    const { themeMode, FONT } = useThemeMode();

    return (<Typography component="div" sx={{ marginRight: "auto" }}>
        <Typography component="h1" variant='h3' sx={{ fontWeight: 600, marginRight: 'auto', fontSize: { xs: FONT.SIZE_24, md: FONT.SIZE_28 } }}>
            {pageInfo?.page}
            {pageInfo?.tooltip ? (
                <InfoTooltip info={pageInfo.tooltip} themeMode={themeMode} />
            ) : null}
        </Typography>
        <AppBreadcrumbs currentPath={location.pathname} />
    </Typography>);
}

export default AppTitle;